// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-addon[data-v-7834360c] {
  border-radius: 0 !important;
}
.company-name-char[data-v-7834360c] {
  display: inline !important;
  font-size: 1em !important;
}
.business-detail[data-v-7834360c] {
  min-height: 40px;
}
.match[data-v-7834360c] {
  font-weight: bold;
}
.dd_shareholder.col-9[data-v-7834360c] {
  margin-left: -10px;
}
.dd_borders[data-v-7834360c] {
  border-bottom: 1px solid white;
}
.dd_borders[data-v-7834360c]:last-child {
  border-bottom: none;
}
`, "",{"version":3,"sources":["webpack://./src/js/netpify/components/np-company-search.vue","webpack://./np-company-search.vue"],"names":[],"mappings":"AACI;EACI,2BAAA;ACAR;ADEI;EACI,0BAAA;EACA,yBAAA;ACAR;ADEI;EACI,gBAAA;ACAR;ADEI;EACI,iBAAA;ACAR;ADEI;EACI,kBAAA;ACAR;ADEI;EACI,8BAAA;ACAR;ADEI;EACI,mBAAA;ACAR","sourcesContent":["\n    .search-addon{\n        border-radius: 0 !important;\n    }\n    .company-name-char {\n        display: inline !important;\n        font-size: 1em !important;\n    }\n    .business-detail {\n        min-height: 40px;\n    }\n    .match {\n        font-weight: bold;\n    }\n    .dd_shareholder.col-9{\n        margin-left: -10px;\n    }\n    .dd_borders {\n        border-bottom: 1px solid white;\n    }\n    .dd_borders:last-child{\n        border-bottom: none;\n    }\n",".search-addon {\n  border-radius: 0 !important;\n}\n.company-name-char {\n  display: inline !important;\n  font-size: 1em !important;\n}\n.business-detail {\n  min-height: 40px;\n}\n.match {\n  font-weight: bold;\n}\n.dd_shareholder.col-9 {\n  margin-left: -10px;\n}\n.dd_borders {\n  border-bottom: 1px solid white;\n}\n.dd_borders:last-child {\n  border-bottom: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
